import React from 'react';

function MenuBarsIcon(props) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M0,2.9c0-0.8,0.6-1.4,1.4-1.4h17.1c0.8,0,1.4,0.6,1.4,1.4s-0.6,1.4-1.4,1.4H1.4C0.6,4.3,0,3.6,0,2.9z M0,10c0-0.8,0.6-1.4,1.4-1.4h17.1c0.8,0,1.4,0.6,1.4,1.4c0,0.8-0.6,1.4-1.4,1.4H1.4C0.6,11.4,0,10.8,0,10z M20,17.1c0,0.8-0.6,1.4-1.4,1.4H1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4h17.1C19.4,15.7,20,16.4,20,17.1z"/>
    </svg>
  );
}

export default MenuBarsIcon;
